var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":_vm.showDialog,"width":"70%","min-height":"800px"},on:{"input":function($event){_vm.showDialog = false},"cancel":_vm.closeDialog}},[_c('qr-scanner',{attrs:{"isFullScrenOnStart":false,"visible":_vm.qrScannerVisible,"isMultiScaner":_vm.isMultiScaner},on:{"decode":_vm.decodeQr,"cancel":_vm.closeDialog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }